const pageNameKey = "alarmProfilesDrawerModal";

export const alarmProfilesDrawerModalEn = {
  [pageNameKey]: {
    title: "Condition Monitoring Profile",
    mainButton: "Add Condition Monitoring Profile",
    placeHolderName: "Placeholder Name",
    placeHolderDescription: "Placeholder Description",
  },
};

export const alarmProfilesDrawerModalPtBr = {
  [pageNameKey]: {
    title: "Perfil de Monitoramento de condição",
    mainButton: "Adicionar perfil de monitoramento de condição",
    placeHolderName: "Nome do placeholder",
    placeHolderDescription: "Descrição do placeholder",
  },
};

export const alarmProfilesDrawerModalDe = {
  [pageNameKey]: {
    title: "Condition Monitoring Profil",
    mainButton: "Condition Monitoring Profil hinzufügen",
    placeHolderName: "Platzhalter Name",
    placeHolderDescription: "Platzhalter Beschreibung",
  },
};

export const alarmProfilesDrawerModalZhHans = {
  [pageNameKey]: {
    title: "条件监控配置文件",
    mainButton: "添加条件监控配置文件",
    placeHolderName: "占位符名称",
    placeHolderDescription: "占位符描述",
  },
};

export const alarmProfilesDrawerModalIt = {
  [pageNameKey]: {
    title: "Profilo di monitoraggio delle condizioni",
    mainButton: "Aggiungi profilo di monitoraggio delle condizioni",
    placeHolderName: "Nome",
    placeHolderDescription: "Descrizione",
  },
};

export const alarmProfilesDrawerModalEs = {
  [pageNameKey]: {
    title: "Perfil de monitoreo de condición",
    mainButton: "Agregar perfil de monitoreo de condiciones",
    placeHolderName: "Nombre del marcador de posición",
    placeHolderDescription: "Descripción del marcador de posición",
  },
};

export const alarmProfilesDrawerModalNl = {
  [pageNameKey]: {
    mainButton: "Conditiebewakingsprofiel toevoegen",
    placeHolderDescription: "Tijdelijke beschrijving",
    placeHolderName: "Tijdelijke naam",
    title: "Conditiebewakingsprofiel",
  },
};

export const alarmProfilesDrawerModalTr = {
  [pageNameKey]: {
    mainButton: "Durum İzleme Profili Ekle",
    placeHolderDescription: "Yer Tutucu Açıklaması",
    placeHolderName: "Yer Tutucu Adı",
    title: "Durum İzleme Profili",
  },
};
